<template>
    <v-container class="mt-16">
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
            v-model="selectedCategory"
            :items="categories"
            label="Select Category"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedDate"
                label="Select Date"
                outlined
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDate"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-file-input
            v-model="file"
            label="Select PDF file"
            outlined
            accept="application/pdf"
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn color="primary" @click="uploadFile">Upload</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="responseStatus !== null">
        <v-col cols="12">
          <v-alert :type="responseStatus === 200 ? 'success' : 'error'">
            {{ responseMessage }}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
import secure_axios from "../services/secure_axios";

export default {
    data() {
        return {
        categories: ['editorial', 'other_category'],
        selectedCategory: null,
        selectedDate: null,
        file: null,
        menu: false,
        responseStatus: null,
        responseMessage: ''
        };
    },
    computed:{
      user() {     
        return this.$store.getters.factsuser;      
      },
      preferedAPI() {
        return this.$store.getters.perferedAPI;
      }, 
    },
    methods: {
        uploadFile() {
            if (!this.selectedCategory || !this.selectedDate || !this.file) {
                this.responseStatus = null;
                this.responseMessage = 'Please select category, date, and upload a file';
                return;
            }

            // Read the file and convert to base64
            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onload = async () => {
                const base64File = reader.result.split(',')[1];

                const formData = new FormData();
                formData.append('date', this.selectedDate.toISOString().split('T')[0]);
                formData.append('category', this.selectedCategory);
                formData.append('file', base64File);
                
                try {
                    const response = await secure_axios.post(this.preferedAPI +'/files/upload_pdf', formData);
                    this.responseStatus = response.status;
                    if (response.status === 200) {
                        this.responseMessage = 'File uploaded successfully';
                    } else {
                        this.responseMessage = `Error uploading file. Status: ${response.status}`;
                    }
                } catch (error) {
                    console.error('Error:', error);
                    this.responseStatus = null; // Or set to a specific error status code if available
                    this.responseMessage = 'An error occurred while uploading the file';
                }
            };
        }
    }
};
</script>

<style scoped>
</style>
  